import React from 'react';
import { Section } from './Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItForSection() {
  const forWho = ['Mujeres latinas en USA con agendas apretadas que necesitan resultados rápidos.', 'Aquellas que sienten que "todo les inflama" incluso si comen poco.', 'Quienes tienen un evento pronto y necesitan sentirse ligeras y cómodas en su ropa.', 'Madres y profesionales estresadas que sufren de pesadez y fatiga por la tarde.'];
  const notForWho = ['Personas que buscan una solución mágica para perder 20 libras en una semana.', 'Quienes no están dispuestas a seguir una guía de alimentación simple por 3 días.', 'Personas con condiciones médicas crónicas que requieren dietas clínicas bajo supervisión.'];
  return <Section className="bg-sage" data-id="element-118">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-119">
        <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-forest" data-id="element-120">
          <h3 className="font-serif text-2xl font-bold text-forest mb-6 flex items-center gap-2" data-id="element-121">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-122" />
            Esto SÍ es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-123">
            {forWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-124">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-125" />
                <span className="text-gray-700" data-id="element-126">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-500" data-id="element-127">
          <h3 className="font-serif text-2xl font-bold text-forest mb-6 flex items-center gap-2" data-id="element-128">
            <XCircle className="w-6 h-6 text-red-500" data-id="element-129" />
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-130">
            {notForWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-131">
                <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-132" />
                <span className="text-gray-700" data-id="element-133">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}